import { SortingState } from '@tanstack/react-table';
import { SortDirection } from '../types';

export function toGraphQlSort(sortingState: SortingState) {
  return sortingState.reduce<Record<string, unknown>>((acc, { id, desc }) => {
    const direction = desc ? SortDirection.Desc : SortDirection.Asc;
    if (!id.includes('.')) {
      acc[id] = direction;
      return acc;
    }
    const parts = id.split('.');
    const leaf = parts.pop() as string;
    let cursor = acc;
    for (const part of parts) {
      const next = (cursor[part] as Record<string, unknown> | undefined) ?? {};
      cursor[part] = next;
      cursor = next;
    }
    cursor[leaf] = direction;
    return acc;
  }, {});
}
